import { MainBanner } from 'components/main-page/home-page/main-banner/MainBanner'
import { useEffect, useState } from 'react'
import moment from 'moment'
import { useFetch } from 'services/useFetch'
import { API_MAIN_BANNER } from 'services/api-home-page/apiMainBanner'
import { convertErrorMessage, formatDateMoment, uploadFileToS3 } from 'utils/utils'
import { Alert } from 'avo-ui'

const INITIAL_STATE = {
    is_show: false,
    banners: [
        {
            desktop_image_url: null,
            mobile_image_url: null,
            url: null,
            published_date: null,
            published_time: null,
        },
    ],
}

const GET_FIELD_NAME = {
    banners: 'Main banner item',
}

const GET_ITEM_FIELD_NAME = {
    desktop_image_url: 'Image desktop',
    mobile_image_url: 'Image mobile',
}

const ITEM_FIELD_NAME_DETAIL = {
    ...GET_ITEM_FIELD_NAME,
    url: 'Link direction',
    published_at: 'Waktu aktif',
}

const ACTIVE_TIME_FIELD_NAME = ['published_date', 'published_time']

export const MainBannerContainer = () => {
    const [reload, setReload] = useState(false)
    const [mainBannerDetail, setMainBannerDetail] = useState(INITIAL_STATE)
    const copyItems = [...(mainBannerDetail?.banners || [])]
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [errorForm, setErrorForm] = useState({})
    const { fetching: getUrlMainBanner } = useFetch(API_MAIN_BANNER.URL_MAIN_BANNER)
    const { fetching: getMainBannerDetail, isLoading } = useFetch(API_MAIN_BANNER.DETAIL)
    const { fetching: updateMainBanner, isLoading: isUpdating } = useFetch(API_MAIN_BANNER.UPDATE)

    const onChangeForm = (item) => {
        setMainBannerDetail({ ...mainBannerDetail, ...item })
    }

    const setItems = (items) => {
        setMainBannerDetail({ ...mainBannerDetail, banners: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        if (ACTIVE_TIME_FIELD_NAME?.includes(name) && !copyItems[index]?.published_time) {
            copyItems[index]['published_time'] = '00:00'
        }
        if (name === 'published_date' && !value) copyItems[index]['published_time'] = null
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                desktop_image_url: null,
                mobile_image_url: null,
                url: null,
                published_date: null,
                published_time: null,
            },
        ])
    }

    const setUploadBanner = async (filesName, uploadDetail) => {
        const newMainBanner = [...mainBannerDetail?.banners]

        try {
            const s3Urls = await getUrlMainBanner({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                newMainBanner[uploadDetail[i]?.index] = {
                    ...newMainBanner[uploadDetail[i]?.index],
                    [uploadDetail[i]?.key]: `${item?.url}${item?.fields?.key}`,
                }
            })
            await Promise.all(apiS3list)
            onSave({ ...mainBannerDetail, banners: newMainBanner })
        } catch (err) {
            console.error(err)
        }

        setIsLoadingUpload(false)
    }

    const validateForm = () => {
        const validateMainBanner = () => {
            const result = []
            mainBannerDetail?.banners?.map((item, index) => {
                Object.keys(item).forEach((key) => {
                    if (GET_ITEM_FIELD_NAME[key] && !item[key]) {
                        result.push({ index, key, message: `${GET_ITEM_FIELD_NAME[key]} wajib diisi` })
                    }
                })
            })
            return result
        }

        return new Promise((resolve, reject) => {
            const errors = {}
            Object.keys(mainBannerDetail).forEach((key) => {
                if (GET_FIELD_NAME[key] && mainBannerDetail[key]?.length === 0) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (GET_FIELD_NAME[key] && validateMainBanner()?.length) {
                    errors['banners_detail'] = validateMainBanner()
                }
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        validateForm().then(async () => {
            const banners = [...mainBannerDetail?.banners]
            const uploadDetail = []
            const filesName = []

            const mapBannerImages = (name, file, index, key) => {
                filesName.push(name?.replace(/\s/g, ''))
                uploadDetail.push({ file, key, index })
            }

            banners.map((item, index) => {
                if (item?.desktop_image_url?.name) {
                    mapBannerImages(
                        item?.desktop_image_url?.name,
                        item?.desktop_image_url?.file,
                        index,
                        'desktop_image_url',
                    )
                }

                if (item?.mobile_image_url?.name) {
                    mapBannerImages(
                        item?.mobile_image_url?.name,
                        item?.mobile_image_url?.file,
                        index,
                        'mobile_image_url',
                    )
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadBanner(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...mainBannerDetail }) => {
        const newPayload = {
            ...payload,
            banners: payload?.banners?.map((item, index) => {
                const { published_date, published_time, ...itemRest } = item
                const published_at = `${published_date} ${published_time}`
                return {
                    ...itemRest,
                    published_at: published_date ? moment(published_at).utc().format('YYYY-MM-DD HH:mm') : null,
                    sequence: index,
                }
            }),
        }
        updateMainBanner(newPayload)
            .then(() => {
                setReload(!reload)
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Main Banner Updated !',
                })
            })
            .catch((error) => setErrorForm(convertErrorMessage(error?.data, GET_FIELD_NAME, ITEM_FIELD_NAME_DETAIL)))
    }

    useEffect(() => {
        getMainBannerDetail().then((response) => {
            const newDetail = {
                ...response?.data,
                banners: response?.data?.banners?.map((item) => {
                    const { published_at, ...itemRest } = item
                    const publishedAt = published_at ? formatDateMoment(published_at, 'YYYY-MM-DD HH:mm') : null
                    const splitPublishedAt = publishedAt?.split(' ')
                    return {
                        ...itemRest,
                        published_date: splitPublishedAt?.[0] || null,
                        published_time: splitPublishedAt?.[1] || null,
                    }
                }),
            }
            setMainBannerDetail(newDetail)
        })
    }, [reload])

    const props = {
        isShow: mainBannerDetail?.is_show,
        items: copyItems,
        setItems,
        onChangeForm,
        onChangeItem,
        onAddNewItem,
        errorForm,
        isLoadingUpload,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <MainBanner {...props} />
}
